import React from 'react';

// Comps
import AccountFormHeader from '@project-stories/ecommerce/Account/AccountFormHeader/AccountFormHeader';
import AccountActivateForm from '@project-stories/ecommerce/Account/AccountActivate/AccountActivateForm';

// Hooks
import useMediaQuery from '@src/hooks/useMediaQuery';
import {Headings} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Headings/Headings";
import {Paragraph} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Paragraph/Paragraph";

const AccountActivate = ({ section, image, imageMobile, headerColorSchema }) => {
    // Settings
    const { title, title_type, title_type_mobile, tagline, body_type, body_type_mobile } = section;
    const headerTitleType = `${title_type_mobile} ${title_type}-lg`;
    const headerTaglineType = `${body_type_mobile} ${body_type}-lg`;

    // Hooks
    const isMobile = useMediaQuery(undefined, 767);

    return (
        <div
            className='bg-parallax relative px-4 py-16'
            style={
                image
                    ? {
                        backgroundImage: `url(${isMobile ? imageMobile.src : image.src})`
                    }
                    : {}
            }
        >
            <div className='relative flex flex-col mx-auto w-full max-w-[500px]'>
                <div className='md:sticky top-[calc(var(--header-height)+1rem)] text-center space-y-4'>
                    {title && (
                        <Headings type='h4' classes={`${headerTitleType}`} text={title}/>
                    )}

                    {tagline && (
                        <Paragraph text={tagline} type={headerTaglineType}/>
                    )}

                    <div className='pt-8'>
                        <AccountActivateForm section={section} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountActivate;
